import React, { createContext, useState, useEffect } from "react";
import api from "../api"; // 👈 Import the central api instance
import ToastMessage from "../components/ToastMessage"; // Your toast component

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(null); // null initially
  const [toast, setToast] = useState(null);

  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000); // auto-hide after 3s
  };

  // Fetch cart from API
  const fetchCart = async () => {
    try {
      const res = await api.get(`/api/cart/data`);
      if (res.data.status === "success") {
        setCart(res.data.cartItems);
      } else {
        setCart([]);
      }
    } catch (err) {
      console.error("Error fetching cart:", err);
      setCart([]);
    }
  };
  const clearCart = () => {
    setCart([]);   // ✅ force empty array so HeaderCart sees length=0
  };
  useEffect(() => {
    const stored = localStorage.getItem("cart");
    if (stored) setCart(JSON.parse(stored));
  }, []);
  // Add product to cart
  const addToCart = async (item) => {
    try {
      const res = await api.post(`/api/cart/add`, item);
      if (res.data.status === "success") {
        setCart(res.data.cartItems);
        showToast("Item added to cart", "success");
      } else {
        showToast(res.data.message || "Failed to add to cart", "error");
      }

      return res.data.message;
    } catch (err) {
      console.error("Error adding to cart:", err);
      showToast("Failed to add to cart", "error");
      return "Failed to add to cart";
    }
  };

  // Update quantity
  const updateQuantity = async (key, quantity) => {
    try {
      const res = await api.post(`/api/cart/update-quantity`, { cart_key: key, quantity });

      if (res.data.status === "success") {
        setCart(res.data.cartItems);
        showToast("Quantity updated!", "success");
      } else {
        showToast(res.data.message || "Failed to update quantity", "error");
      }
    } catch (err) {
      console.error("Error updating quantity:", err);
      showToast("Failed to update quantity", "error");
    }
  };

  // Remove item
  const removeItem = async (key) => {
    try {
      const res = await api.post(`/api/cart/remove-item`, { cart_key: key });

      if (res.data.status === "success") {
        setCart(res.data.cartItems);
        showToast("Item removed!", "success");
      } else {
        showToast(res.data.message || "Failed to remove item", "error");
      }
    } catch (err) {
      console.error("Error removing item:", err);
      showToast("Failed to remove item", "error");
    }
  };

  useEffect(() => {
    fetchCart(); // Fetch on mount
  }, []);

  return (
    <CartContext.Provider value={{ cart, addToCart, updateQuantity, removeItem,clearCart,showToast,fetchCart }}>
      {children}
      {toast && (
        <ToastMessage
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </CartContext.Provider>
  );
};
